import React from "react";
import "./Why_We_Rank_Among_Top_Solar.css";
import { WhyWeRanks } from "../../../utils/apis/aboutus/Aboutus.js";
import { useContext, useEffect, useState } from "react";
import { Context } from "../../../utils/context";
import { IDS } from "../../../utils/common";

const data = [
  { id: "01", text: "Strong local execution team" },
  { id: "02", text: "Proven government project handling" },
  { id: "03", text: "Trusted by residential, MSME & institutional customers" },
  { id: "04", text: "Transparent billing & honest system sizing" },
  { id: "05", text: "High customer satisfaction & repeat clients" },
  { id: "06", text: "Focus on safety, quality & lifecycle service" },
  {
    id: "07",
    text: "Strong relationship with DISCOM & financial institutions",
  },
  { id: "08", text: "Reliable O&M and post-installation support" },
];

const WhyWeRankAmongTopSolar = () => {
  const { IMG_URL } = useContext(Context);

  const [whywerank, setWhyWeRank] = useState([]);

  const getWhyWeRank = async () => {
    const res = await WhyWeRanks();

    if (res?.success) {
      setWhyWeRank(res?.data?.data || []);
    }
  };

  useEffect(() => {
    getWhyWeRank();
  }, []);

  return (
    <section className="why_section">
      <div className="container">
        <h2 className="section_title">
          Why We Rank Among Top Event Management Companies in Konkan
        </h2>

        <div className="grid_container row">
          {whywerank.map((item, index) => (
            <div key={index} className="col-12 col-sm-6 col-md-6 col-lg-3">
              <div className="grid_item">
                <div className="number_circle">{index + 1}</div>
                <p>{item.name}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyWeRankAmongTopSolar;

// import React from "react";
// import "./Why_We_Rank_Among_Top_Solar.css";

// const data = [
//   { id: "01", text: "Strong local execution team" },
//   { id: "02", text: "Proven government project handling" },
//   { id: "03", text: "Trusted by residential, MSME & institutional customers" },
//   { id: "04", text: "Transparent billing & honest system sizing" },
//   { id: "05", text: "High customer satisfaction & repeat clients" },
//   { id: "06", text: "Focus on safety, quality & lifecycle service" },
//   {
//     id: "07",
//     text: "Strong relationship with DISCOM & financial institutions",
//   },
//   { id: "08", text: "Reliable O&M and post-installation support" },
// ];

// const WhyWeRankAmongTopSolar = () => {
//   return (
//     <section className="why_section">
//       <div className="container">
//         <h2 className="section_title">
//           Why We Rank Among Top Solar EPCs in Konkan
//         </h2>

//         <div className="row">
//           {data.map((item) => (
//             <div key={item.id} className="col-12 col-md-6 col-lg-3 mb-4">
//               <div className="grid_item">
//                 <div className="number_circle">{item.id}</div>
//                 <p>{item.text}</p>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>
//     </section>
//   );
// };

// export default WhyWeRankAmongTopSolar;
